import { render, staticRenderFns } from "./ProductsFeed.vue?vue&type=template&id=737214ca&lang=pug&"
import script from "./ProductsFeed.vue?vue&type=script&lang=js&"
export * from "./ProductsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports